import { render, staticRenderFns } from "./OrderItemsByAddress.vue?vue&type=template&id=789eccfa&scoped=true"
import script from "./OrderItemsByAddress.vue?vue&type=script&lang=js"
export * from "./OrderItemsByAddress.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsByAddress.vue?vue&type=style&index=0&id=789eccfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789eccfa",
  null
  
)

export default component.exports